module.exports = __webpack_public_path__ + "static/avatar-869d41b15cc24197ffadfae8196df5ba.png";